import { useNavigate, useLocation } from "@tanstack/react-router";

import { ROUTES } from "../routes";

export function useNavigateToLink() {
  const navigate = useNavigate();
  const location = useLocation();

  // TODO : this is not typed properly, i.e. it doesn't properly check types
  // against what `navigate` expects
  const navigateToLink = (e: React.MouseEvent, href: string) => {
    e.preventDefault();

    if (href === ROUTES.login) {
      window.plausible?.("Clicked Log In");
    } else if (href.startsWith(ROUTES.register)) {
      window.plausible?.("Clicked Sign Up");
    }

    // Check if it's an external URL
    if (href.startsWith("http://") || href.startsWith("https://")) {
      window.location.href = href;
      return;
    }

    // Check if we're clicking the same hash on the same page
    const currentPath = location.pathname;
    const [targetPath, targetHash] = href.split("#");
    const isCurrentPage = !targetPath || targetPath === currentPath;
    const isCurrentHash = targetHash && location.hash === targetHash;

    if (isCurrentPage && isCurrentHash) {
      // Already on this hash - manually scroll to it
      const element = document.getElementById(targetHash);
      if (element) {
        const yOffset = -80; // Offset for fixed header
        const y =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    } else {
      navigate({ to: targetPath, hash: targetHash });
    }
  };

  return navigateToLink;
}
